import { gql } from '@apollo/client';
import { eventFields } from '../../providers/graphql';

export const updateEventMutation = gql`
  mutation UpdateEvent2($input: UpdateEventInput!) {
    updateEvent(input: $input) {
      event {
        id
        ...EventFields
        spaceAvailability
      }
      errors {
        message
      }
    }
  }
  ${eventFields}
`;

export const removeEventTourMutation = gql`
  mutation RemoveEventTour($input: RemoveEventTourInput!) {
    removeEventTour(input: $input) {
      event {
        id
        tourStartDate
        tourStartOffset
        tourEndOffset
      }
      errors {
        message
      }
    }
  }
`;

export const removeEventRehearsalMutation = gql`
  mutation RemoveEventRehearsal($input: RemoveEventRehearsalInput!) {
    removeEventRehearsal(input: $input) {
      event {
        id
        rehearsalStartDate
        rehearsalStartOffset
        rehearsalEndOffset
      }
      errors {
        message
      }
    }
  }
`;

export const resendReviewRequestMutation = gql`
  mutation ResendReviewRequest($input: ResendReviewRequestInput!) {
    resendReviewRequest(input: $input) {
      errors {
        message
      }
    }
  }
`;

export const duplicateEventMutation = gql`
  mutation DuplicateEvent($input: DuplicateEventInput!) {
    duplicateEvent(input: $input) {
      event {
        id
        ...EventFields
      }
      errors {
        message
      }
    }
  }
  ${eventFields}
`;
